<script>
  import { Lightbox } from "svelte-lightbox";
  import { onMount } from "svelte";
  import { vratSubor } from "../../../api/file";
  import get from "get-value";
  export let data;

  const fileName = data.image.split("/").pop();
  let lightboxProgrammaticController;

  async function getFile(url, filename) {
    await vratSubor(url, filename);
  }

  /* onMount(async () => {
    const response = await vratObrazok(data.image, fileName);
    console.log(response);
  }); */
</script>

<span on:click={getFile(get(data, "image"), get(data, "title"))}
  >{data.title}</span
>

<style lang="scss">
  span {
    cursor: pointer;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
</style>
